// Admin-only control to reset the Insights onboarding (intro banner + guided tour)
// so it can be re-seen while the new UI is being tested. Renders nothing for
// non-admins. Kept as its own component so the admin gating is unit-testable
// without mounting the full chat screen.

import { RotateCcw } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';

const InsightTourResetButton: React.FC<{ onReset: () => void }> = ({ onReset }) => {
  const { isAdmin } = useAuth();
  if (!isAdmin) return null;

  return (
    <button
      onClick={onReset}
      title="Reset the Insights intro banner & tour (admin)"
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium text-[#6B7280] bg-[#FAFBFC] border border-[#E5E7EB] hover:border-[#07E5D1] hover:text-[#07E5D1] transition-colors"
    >
      <RotateCcw className="w-3.5 h-3.5" />
      Reset tour
    </button>
  );
};

export default InsightTourResetButton;
